export function buttonOptionSet() {
	document.addEventListener('change', function (e) {
		if (!e.target.matches('.button-option input')) {
			return;
		}
		const wrapper = e.target.closest('.button-optionset');
		if (!wrapper) {
			return;
		}

		// Checkbox button set (multi-select with optional max)
		if (e.target.type === 'checkbox') {
			const max = parseInt(wrapper.dataset.maxSelected || '', 10);
			if (!Number.isNaN(max) && max > 0 && e.target.checked) {
				const checked = wrapper.querySelectorAll('.button-option input[type="checkbox"]:checked');
				if (checked.length > max) {
					e.target.checked = false;
					return;
				}
			}

			const option = e.target.closest('.button-option');
			const optionWrapper = e.target.closest('.option-wrapper');
			if (option) option.classList.toggle('selected', e.target.checked);
			if (optionWrapper) optionWrapper.classList.toggle('selected', e.target.checked);
			return;
		}

		wrapper.querySelectorAll('.button-option').forEach(option => {
			option.classList.remove('selected');
		});
		wrapper.querySelectorAll('.option-wrapper').forEach(optionWrapper => {
			optionWrapper.classList.remove('selected');
		});

		e.target.closest('.button-option').classList.add('selected');
		e.target.closest('.option-wrapper').classList.add('selected');
	});
}
export function quantityField() {
	document.addEventListener('click', e => {

		const plus = e.target.closest('.quantity-field__plus');
		const minus = e.target.closest('.quantity-field__minus');

		if (!plus && !minus) {
			return;
		}

		const wrapper = e.target.closest('.quantity-field');
		const input = wrapper.querySelector('input');

		const step = Number(input.step || 1);
		const min = Number(input.min || 0);
		const max = Number(input.max || Number.MAX_SAFE_INTEGER);

		let value = Number(input.value || 0);

		if (plus) {
			value += step;
		}

		if (minus) {
			value -= step;
		}

		value = Math.max(min, Math.min(max, value));

		input.value = value;

		input.dispatchEvent(new Event('change', {
			bubbles: true
		}));

	});
}

export function btnDeleteAction() {
	document.addEventListener('click', e => {

		const btnDelete = e.target.closest('.btn-delete');

		if (!btnDelete) {
			return;
		}

		const cakeId = btnDelete.dataset.cakeId;
		const productOrderId = btnDelete.dataset.productOrderId;

		if (cakeId) {
			window.location.href = `/order/delete-cake/${cakeId}`;
			return;
		}

		if (productOrderId) {
			window.location.href = `/order/delete-product/${productOrderId}`;
		}

	});
}